import { render, staticRenderFns } from "./SideBarPatient.vue?vue&type=template&id=042b4b39&scoped=true&"
import script from "./SideBarPatient.vue?vue&type=script&lang=ts&"
export * from "./SideBarPatient.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarPatient.vue?vue&type=style&index=0&id=042b4b39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042b4b39",
  null
  
)

export default component.exports